import { writable } from 'svelte/store';
import ConnectionStore from './connection';
const createStore = () => {
    const messages = writable([]);
    const gameTypes = writable([]);
    const usersOnline = writable(0);
    const openGames = writable([]);
    ConnectionStore.onLobbyChatMessage((msg) => messages.update((msgs) => msgs.concat(msg.detail)));
    ConnectionStore.onGameTypes(({ detail }) => gameTypes.set(detail.gameTypes));
    ConnectionStore.onUsersOnline(({ detail }) => usersOnline.set(detail.usersOnline));
    ConnectionStore.onOpenGameList(({ detail }) => openGames.set(detail.openGames));
    const sendChatMessage = (message) => {
        ConnectionStore.loggedIn.subscribe((loggedIn) => {
            if (loggedIn)
                ConnectionStore.username.subscribe((username) => {
                    ConnectionStore.send({
                        message,
                        senderName: username,
                    });
                })();
        })();
    };
    return {
        chatMessages: { subscribe: messages.subscribe },
        gameTypes: { subscribe: gameTypes.subscribe },
        usersOnline: { subscribe: usersOnline.subscribe },
        openGames: { subscribe: openGames.subscribe },
        sendChatMessage,
    };
};
const lobbyStore = createStore();
export default lobbyStore;
